import { useMutation, useQuery } from 'react-query';
import { RecruitmentSourcesService } from '@api/RecruitmentSourcesService';
import { onDefaultError } from '../helpers/commonHelpers';
// Records
const useListRecruitmentSources = (
  [page_no, searchText, selectedStatus],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    ['recruitment-candidate-sources-list', page_no, searchText, selectedStatus],
    RecruitmentSourcesService.listRecruitmentSources,
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};
// Create
const useAddRecruitmentSources = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentSourcesService.addRecruitmentSources, {
    onSuccess,
    onError
  });
};
// Details
const useViewRecruitmentSources = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('recruitment-candidate-sources-view', () => RecruitmentSourcesService.viewRecruitmentSources(id), {
    onSuccess,
    onError
  });
};
// Details
const useShowRecruitmentSources = (id, onSuccess, onError = onDefaultError) => {
  return useQuery('recruitment-candidate-sources-show', () => RecruitmentSourcesService.showRecruitmentSources(id), {
    onSuccess,
    onError
  });
};
const useUpdateRecruitmentSources = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentSourcesService.updateRecruitmentSources, {
    onSuccess,
    onError
  });
};
// Delete
const useDeleteRecruitmentSources = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentSourcesService.deleteRecruitmentSources, {
    onSuccess,
    onError
  });
};
const useUpdateRecruitmentSourcesStatus = (onSuccess, onError = onDefaultError) => {
  return useMutation(RecruitmentSourcesService.changeStatusRecruitmentSources, {
    onSuccess,
    onError
  });
};
export {
    useListRecruitmentSources,
    useAddRecruitmentSources,
    useViewRecruitmentSources,
    useShowRecruitmentSources,
    useDeleteRecruitmentSources,
    useUpdateRecruitmentSourcesStatus,
    useUpdateRecruitmentSources
};
